import { useHead } from "@unhead/react";

import { SEOHead } from "@/components/helpers/seo/SEOHead";
import { isWorkspaceAdmin } from "@/components/helpers/workspace/permissions";
import { PermissionError } from "@/components/pages_public/403";
import { LIGHTEST_BACKGROUND } from "@/css/constants";

import { ScenarioAssignmentContent } from "./ScenarioAssignmentContent";

export function RoleplayAssignmentPage() {
  useHead({
    bodyAttrs: { style: { backgroundColor: LIGHTEST_BACKGROUND } },
  });

  const isAdmin = isWorkspaceAdmin();

  if (!isAdmin) {
    return <PermissionError />;
  }

  return (
    <>
      <SEOHead title="Roleplays Assignment – Exec" />
      <ScenarioAssignmentContent pageType="roleplayDetail" />
    </>
  );
}
